module.exports = __webpack_public_path__ + "img/kep4-3.1de86d22.jpg";